<template>
  <div :id="`available-capper-id-${capper.service}`">

    <h3 :class="`title is-3 mb-3 ${!confirmed ? 'has-text-danger' : 'has-text-primary'}`">
      <span class="has-text-danger"><b-icon icon="lock" size="is-medium"/></span>
      {{!confirmed ? 'UNCONFIRMED: ' : ''}} {{capper.title}}
    </h3>

    <div class="content mb-6 is-medium">
      <p>{{confirmed ? capper.copy : `Call ${propertyPhone} to confirm this order!`}}</p>

      <b-notification v-if="confirmed && biggestPick" :closable="false" type="is-info" has-icon>
        {{biggestPickIntro}} <strong>{{capper.title}}</strong> {{biggestPickOutro}}
      </b-notification>

      <b-notification v-if="confirmed && capper.couponPromo && !burnedOutOnCouponPromo" :closable="false" type="is-success" has-icon>
        <p>You qualify for a coupon code</p>

        <p>
          <button v-if="!revealCoupon" @click="registerCouponView" class="button is-success is-light">Reveal Code</button>

          <span v-else>Your code is: <strong>{{ capper.couponPromo.coupon }}</strong>
            <br>
            <br>
            Apply your coupon here:
          <a :href="couponPromoUrl" class="button is-success is-light">{{capper.couponPromo.cta}}</a>
        </span>
        </p>
      </b-notification>

      <p v-if="(record.length && confirmed) || (pendingPicks.length && confirmed)">
        <a :href="capper.paymentLinks[0] ? capper.paymentLinks[0].url : `tel:${propertyPhone}`"
           :class="`button is-primary is-fullwidth-mobile is-medium ${paymentLinkClass}`">
          {{capper.paymentLinks[0] ? capper.paymentLinks[0].cta : 'Call Me'}}
        </a>
      </p>
    </div>

    <div v-if="record.length && confirmed" class="mb-5">
      <h4 class="title is-4">
        {{recordLabel}}:
        <strong class="has-text-weight-bold">
          {{recordWins}} - {{recordLosses}} {{ recordPushes ? ` - ${recordPushes}` : ''}}
        </strong>
      </h4>

      <div class="table-container">
        <table class="table is-fullwidth is-striped is-hoverable is-narrow">
          <thead>
          <tr>
            <th class="is-size-5">Date</th>
            <th class="is-size-5">Result</th>
            <th class="is-size-5">Wager</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="wager in record" :key="`record-${wager.id}`">
            <td class="is-size-5">{{ wager.date.split('/').slice(0, 2).join('/') }}</td>
            <td :class="`is-size-5 ${wager.isWinner ? 'has-text-weight-bold' : ''}`">
              {{ isWinLossOrPush(wager.isWinner) }}
            </td>
            <td>
              <span class="is-size-6">{{ wager.awayTeam }}<br/>{{wager.homeTeam}}</span>
              <br/>
              <strong class="is-size-5">{{wager.pick}}</strong></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h4 v-if="pendingPicks.length" class="title is-4">
      {{
        confirmed ?
            pendingPicksLabel :
            `Upon confirmation you get access to ${pendingPicks.length > 1 ? 'these' : 'this'} pick${pendingPicks.length > 1 ? 's' : ''}:`
      }}
    </h4>

    <div v-for="(pick, i) in pendingPicks"
         :key="`pick-${pick.id}`"
         :class="`${pickWrapperClasses(i === pendingPicks.length - 1)} mb-6`">
      <pending-pick :pick="pick" :column-classes="pickColumnClasses()" :should-obscure-match-up="capper.obscurePending" />
    </div>

    <div v-if="confirmed" class="buttons is-block-mobile">
      <a v-for="link in capper.paymentLinks"
         :key="`${link.cta}-${link.url}`"
         :href="link.url"
         :class="`button is-primary is-fullwidth-mobile is-medium ${paymentLinkClass}`">
        {{link.cta}}
      </a>
    </div>

    <div v-else class="buttons is-block-mobile is-centered">
      <a :href="`tel:${propertyPhone}`"
         :class="`button is-primary is-fullwidth-mobile ${paymentLinkClass}`">
        Call To Confirm Now
      </a>
    </div>

  </div>
</template>

<script>
import {pickWrapperClasses, pickColumnClasses, adjustTSSRiskAmounts} from '@/utils/misc';
import PendingPick from '@/components/members/PendingPick';

export default {
  components: {
    PendingPick
  },
  props: {
    capper: Object,
    confirmed: Boolean,
    cbfidItem: String,
  },
  data() {
    return {
      pendingPicks: [],
      propertyPhone: process.env.VUE_APP_PHONE,
      pendingPicksLabel: process.env.VUE_APP_UPCOMING_PICKS_LABEL || 'Upcoming Picks',
      record: [],
      recordLabel: process.env.VUE_APP_RECENT_RESULTS_LABEL || 'Recent Results',
      paymentLinkClass: process.env.VUE_APP_PAY_LINK_COLOR || 'is-primary',
      biggestPick: null,
      biggestPickIntro: process.env.VUE_APP_BIGGEST_PICK_INTRO || 'My confidence can be measured by the amount I risk on a any given wager... And today, among',
      biggestPickOutro: process.env.VUE_APP_BIGGEST_PICK_OUTRO || 'lies my biggest bet. I highly suggest you add this service to your account now. See below for details.',
      burnedOutOnCouponPromo: true,
      revealCoupon: false,
      /*wistiaVidId: '7kc2m0jyq5',
      wistiaIframeCode: null,
      wistiaVidRes: null,*/
    }
  },
  mounted() {

    if ('r' in this.capper && Array.isArray(this.capper.r)) {
      this.record = this.capper.r;
    }

    /*fetch(`https://fast.wistia.net/oembed?embedType=iframe&url=http://fast.wistia.net/embed/iframe/${this.wistiaVidId}`)
      .then(async res => {
        if (res.ok) {
          this.wistiaVidRes = await res.json();
          this.wistiaIframeCode = this.wistiaVidRes.html.split('<' + '/' + 'iframe' + '>' + "\n" + '<' + 'script')[0] + '<' + '/' + 'iframe' + '>';
        }
      })*/

    if ('pending' in this.capper && Array.isArray(this.capper.pending)) {
      let pending = this.capper.isTSS ? this.adjustTSSRiskAmounts(this.capper.pending) : this.capper.pending;

      this.pendingPicks = pending.filter(pick => {
        let isClosedPick = pick.dateTime < new Date().getTime();
        let shouldHide = this.capper.hideClosedPicks;

        return shouldHide ? !isClosedPick : true;
      });
    }

    if (this.capper.biggestPick) {
      this.biggestPick = this.capper.biggestPick;
    }

    if (this.capper.couponPromo) {
      let seenLast = JSON.parse(localStorage.getItem('lastShownCoupon') || '0');
      this.burnedOutOnCouponPromo = (new Date().getTime() - seenLast) < 1000*60*60*24*1;
    }
  },
  methods: {
    pickWrapperClasses: pickWrapperClasses,
    pickColumnClasses: pickColumnClasses,
    adjustTSSRiskAmounts: adjustTSSRiskAmounts,
    registerCouponView: function () {
      this.revealCoupon = true;
      localStorage.setItem('lastShownCoupon', new Date().getTime().toString());
    },
    isWinLossOrPush: function (result) {
      if (result === true) {
        return 'WIN';
      }

      if (result === false) {
        return 'Loss';
      }

      return 'Push'
    }
  },
  computed: {
    recordWins: function () {
      return this.record.filter(wager => wager.isWinner).length;
    },
    recordLosses: function () {
      return this.record.filter(wager => wager.isWinner ===  false).length;
    },
    recordPushes: function () {
      return this.record.filter(wager => wager.isWinner !== true && wager.isWinner !== false).length;
    },
    couponPromoUrl: function () {
      if (!this.capper.couponPromo) {
        return '';
      }

      let parsedPayLink = this.capper.couponPromo.url.split('?');
      let payLink = parsedPayLink[0];
      let payLinkParams = new URLSearchParams(parsedPayLink[1]);

      if (this.capper.couponPromo?.processor === 'clickbank') {
        payLinkParams.append('coupon', this.capper.couponPromo.coupon);
      }

      return `${payLink}?${payLinkParams.toString()}`;
    }
  }
}
</script>